// Hook to post the /user/merge response

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useState } from 'react';

export const usePostUserMerge = (t) => {
    const [saving, setSaving] = useState(false);

    const postUserMerge = useCallback(
        async ({ params }) => {
            try {
                setSaving(true);
                await axios.post('/user/merge', params);
                Notify.success(t('Users.mergeUsers.notifyMerge'), {
                    seconds: 10
                });
                setSaving(false);
                return true; // success = true
            } catch (err) {
                debug.e('Unable to merge users.', err);
                Notify.error(t('Users.mergeUsers.notifyMergeFail'));
                setSaving(false);
                return false; // success = false
            }
        },
        [t]
    );

    return { postUserMerge, saving };
};
